module.exports = __webpack_public_path__ + "static/media/partner-6.e912057c.png";